module.exports = __webpack_public_path__ + "media/images/brands/brand-in-5a11a8fcdee374080d4d1ad545780cda.jpg";